import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebRoutingModule } from '../../web-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { InptAeropuertosGroupedComponent } from './components/flights/components/aeropuertos-grouped/aeropuertos-grouped.component';
import { InptAirportsComponent } from './components/inputs/aeropuertos/airports.component';
import { InptAirlinesComponent } from './components/inputs/airlines/airlines.component';
import { InptDestBusComponent } from './components/inputs/dest-bus/dest-bus.component';
import { PruebaArrayComponent } from './components/inputs/prueba-array/prueba-array.component';
import { IsicComponent } from './components/modals/isic/isic.component';
import { DatepickerComponent } from './components/inputs/datepicker/datepicker.component';
import { PassengersComponent } from './components/inputs/passengers/passengers.component';
import { MenuComponent } from './components/inputs/menu/menu.component';
import { InsurancePassengersComponent } from './components/insurance/components/insurance-passengers/insurance-passengers.component';
import { HuespedesComponent } from './components/inputs/huespedes/huespedes.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment.prod';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { WidgetComponent } from './widget.component';
import { FlightsComponent } from './components/flights/flights.component';
import { HotelsComponent } from './components/hotels/hotels.component';
import { InsuranceComponent } from './components/insurance/insurance.component';
import { FlightAndHotelComponent } from './components/flight-and-hotel/flight-and-hotel.component';
import { ToursComponent } from './components/tours/tours.component';
import { WebModule } from '../../web.module';
import { GeneralComponentsModule } from '../General/components_general.module';
import { InptMesesComponent } from './components/tours/components/meses/meses.component';
import { PtDestFlightComponent } from './components/flight-and-hotel/components/pt-dest-flight/pt-dest-flight.component';
import { PtOriginFlightComponent } from './components/flight-and-hotel/components/pt-origin-flight/pt-origin-flight.component';
import { PtDestBusComponent } from './components/flight-and-hotel/components/pt-dest-bus/pt-dest-bus.component';
import { PtOriginBusComponent } from './components/flight-and-hotel/components/pt-origin-bus/pt-origin-bus.component';
import { ExpHotelsComponent } from './components/hotels/components/exp-hotels/exp-hotels.component';
import { NavWidgetComponent } from './components/nav-widget/nav-widget.component';
import { WidgetDeviceComponent } from './components/widget-device/widget-device.component';
import { CountryTravelComponent } from './components/tours/components/country-travel/country-travel.component';
import { CityTravelComponent } from './components/tours/components/city-travel/city-travel.component';
import { RegionesTravelComponent } from './components/tours/components/regiones-travel/regiones-travel.component';
import { SearchFlightTypeComponent } from './components/flights/components/search-flight-type/search-flight-type.component';
import { FlightMultidestinoComponent } from './components/flights/components/flight-multidestino/flight-multidestino.component';

@NgModule({
  imports: [
    CommonModule,
    // WebRoutingModule,
    CoreModule,
    MatCheckboxModule,
    AgmCoreModule.forRoot({
      apiKey: environment.map_key
    }),
    AgmCoreModule,
    VgCoreModule,
    VgControlsModule,
    GeneralComponentsModule
    // WebModule
  ],
  declarations: [
    NavWidgetComponent,
    WidgetDeviceComponent,
    InptAeropuertosGroupedComponent,
    InptAirportsComponent,
    CountryTravelComponent,
    CityTravelComponent,
    InptAirlinesComponent,
    InptDestBusComponent,
    InptMesesComponent,
    PruebaArrayComponent,
    IsicComponent,
    DatepickerComponent,
    PassengersComponent,
    MenuComponent,
    InsurancePassengersComponent,
    HuespedesComponent,
    WidgetComponent,
    FlightsComponent,
    HotelsComponent,
    InsuranceComponent,
    FlightAndHotelComponent,
    ToursComponent,
    PtDestFlightComponent,
    PtOriginFlightComponent,
    PtDestBusComponent,
    PtOriginBusComponent,
    ExpHotelsComponent,
    RegionesTravelComponent,
    SearchFlightTypeComponent,
    FlightMultidestinoComponent
  ],
  exports: [
    InptAeropuertosGroupedComponent,
    InptAirportsComponent,
    InptAirlinesComponent,
    InptDestBusComponent,
    // HuespedesComponent,
    PruebaArrayComponent,
    IsicComponent,
    WidgetComponent,
    FlightsComponent,
    PassengersComponent,
    MenuComponent
  ]
})
export class WidgetModule {}
